import { render, staticRenderFns } from "./moreChart.vue?vue&type=template&id=8a3d7bf2"
import script from "./moreChart.vue?vue&type=script&lang=js"
export * from "./moreChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a3d7bf2')) {
      api.createRecord('8a3d7bf2', component.options)
    } else {
      api.reload('8a3d7bf2', component.options)
    }
    module.hot.accept("./moreChart.vue?vue&type=template&id=8a3d7bf2", function () {
      api.rerender('8a3d7bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/moreChart.vue"
export default component.exports